<div fxLayout="column" fxLayoutAlign="start stretch" [hidden]="!ViewReady">
    <h2 class="mat-headline">Create New Request</h2>
    <div>
        Use the form provided here below to create a new request in the IRIS system. Please be sure to provide all required entries in
        the form.
    </div>
    <form [formGroup]="RequestForm" novalidate #requestfrm="ngForm">
        <div
            fxLayout="row"
            fxLayoutAlign="start center"
            fxLayoutGap="30px"
            fxLayout.lt-md="column"
            fxLayoutAlign.lt-md="start stretch"
            fxLayoutGap.lt-md="10px"
        >
            <div
                fxLayout="row"
                fxLayoutAlign="start center"
                fxLayoutGap="15px"
                [fxFlex]="User?.CurrentRole === 'Facilitator' || User?.CurrentRole === 'Developer' ? '45' : 'auto'"
                fxFlex.lt-md="auto"
            >
                <app-form-label [required]="true">Subject:</app-form-label>
                <mat-form-field appearance="outline" fxFlex>
                    <input
                        #subjectinput
                        type="text"
                        matInput
                        placeholder="Enter subject of request..."
                        aria-label="Subject of request"
                        formControlName="Subject"
                        maxlength="250"
                    />
                    <mat-hint align="start">Limit of 250 characters</mat-hint>
                    <mat-hint align="end">{{ RequestForm?.get('Subject')?.value?.length || 0 }}/250</mat-hint>
                    <mat-error *ngIf="RequestForm?.get('Subject')?.hasError('required')">Required.</mat-error>
                    <mat-error *ngIf="RequestForm?.get('Subject')?.hasError('maxLength')">Over character limit (200).</mat-error>
                </mat-form-field>
            </div>
            <div
                fxLayout="row"
                fxLayoutAlign="start center"
                fxLayoutGap="15px"
                *ngIf="User?.CurrentRole === 'Facilitator' || User?.CurrentRole === 'Developer'"
                fxFlex="45"
                fxFlex.lt-md="auto"
            >
                <app-form-label [required]="true">Category:</app-form-label>
                <mat-form-field appearance="outline" fxFlex>
                    <mat-select
                        matInput
                        formControlName="RequestCategory"
                        placeholder="Category..."
                        aria-label="Request Category Selection List"
                    >
                        <mat-option *ngFor="let cat of AllCategories" [value]="cat">
                            <span
                                >{{ cat.CategoryDescription }}
                                <span *ngIf="cat.CabinetMember"
                                    >({{ cat?.CabinetMember?.FirstName | titleCase }}
                                    {{ cat?.CabinetMember?.LastName | titleCase }})</span
                                ></span
                            >
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="RequestForm?.get('RequestCategory')?.hasError('required')">Required.</mat-error>
                </mat-form-field>
            </div>
        </div>
        <div
            *ngIf="IsBoardAssistant"
            fxLayout="row"
            fxLayoutAlign="start center"
            fxLayoutGap="30px"
            fxLayout.lt-md="column"
            fxLayoutAlign.lt-md="start stretch"
            fxLayoutGap.lt-md="10px"
        >
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" fxFlex="auto" fxFlex.lt-md="auto">
                <app-form-label [required]="true">Board Member:</app-form-label>
                <mat-form-field appearance="outline" fxFlex>
                    <mat-select
                        matInput
                        formControlName="RequestBoardMember"
                        placeholder="Board Member..."
                        aria-label="Request Board Member Selection List"
                    >
                        <mat-option [value]="null">Board Member...</mat-option>
                        <mat-option *ngFor="let board of BoardMembers" [value]="board"
                            >{{ board.LastName | titleCase }}, {{ board.FirstName | titleCase }} - District
                            {{ board.District }}</mat-option
                        >
                    </mat-select>
                    <mat-error *ngIf="RequestForm?.get('RequestBoardMember')?.hasError('required')">Required.</mat-error>
                </mat-form-field>
            </div>
        </div>
        <div
            fxLayout="row"
            fxLayoutAlign="start center"
            fxLayoutGap="30px"
            fxLayout.lt-md="column"
            fxLayoutAlign.lt-md="start stretch"
            fxLayoutGap.lt-md="10px"
        >
            <div
                fxLayout="row"
                fxLayoutAlign="start center"
                fxLayoutGap="15px"
                *ngIf="['BoardMember', 'BoardAssistant', 'Facilitator', 'Developer'].includes(User?.CurrentRole)"
                fxFlex="45"
                fxFlex.lt-md="auto"
            >
                <app-form-label [required]="true">Priority:</app-form-label>
                <mat-form-field appearance="outline" fxFlex>
                    <mat-select
                        matInput
                        formControlName="Priority"
                        placeholder="Priority..."
                        aria-label="Request Priority Selection List"
                    >
                        <mat-option [value]="1">1 - Urgent</mat-option>
                        <mat-option [value]="2">2 - High</mat-option>
                        <mat-option [value]="3">3 - Routine</mat-option>
                        <mat-option [value]="4">4 - Low</mat-option>
                    </mat-select>
                    <mat-hint *ngIf="RequestForm?.get('Priority')?.value && RequestForm?.get('Priority')?.value !== 4">
                        <em>Suggested for requests needed within {{ RequestForm?.get('Priority')?.value | priorityTime }}</em>
                    </mat-hint>
                    <mat-error *ngIf="RequestForm?.get('Priority')?.hasError('required')">Required.</mat-error>
                </mat-form-field>
            </div>
            <!-- <div
                fxLayout="row"
                fxLayoutAlign="start center"
                fxLayoutGap="15px"
                *ngIf="User?.CurrentRole === 'Facilitator' || User?.CurrentRole === 'Developer'"
            >
                <app-form-label>Request Type:</app-form-label>
                <mat-form-field appearance="outline">
                    <mat-select
                        matInput
                        formControlName="RequestSource"
                        placeholder="Request source..."
                        aria-label="Request Source Selection List"
                    >
                        <mat-option [value]="null">Request source...</mat-option>
                        <mat-option [value]="0">Board</mat-option>
                        <mat-option [value]="1">Constituent</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div
                fxLayout="row"
                fxLayoutAlign="start center"
                fxLayoutGap="15px"
                *ngIf="
                    (User?.CurrentRole === 'Facilitator' || User?.CurrentRole === 'Developer') &&
                    RequestForm?.get('RequestSource')?.value === 1
                "
            >
                <app-form-label>Constituent:</app-form-label>
                <mat-form-field appearance="outline">
                    <input
                        type="text"
                        matInput
                        formControlName="RequestSourceDescription"
                        placeholder="Enter constituent..."
                        aria-label="Request Constituent Name"
                    />
                    <mat-hint align="start">Limit 200 characters</mat-hint>
                    <mat-hint align="end">{{ RequestForm?.get('RequestSourceDescription')?.value?.length || 0 }}/200</mat-hint>
                    <mat-error *ngIf="RequestForm?.get('RequestSourceDescription')?.hasError('required')">Required.</mat-error>
                    <mat-error *ngIf="RequestForm?.get('RequestSourceDescription')?.hasError('maxLength')"
                        >Over character limit (200).</mat-error
                    >
                </mat-form-field>
            </div> -->
            <div
                fxLayout="row"
                fxLayoutAlign="start center"
                fxLayoutGap="15px"
                *ngIf="['Facilitator', 'Developer'].includes(User?.CurrentRole)"
                fxFlex
                fxFlex.lt-md="auto"
            >
                <app-form-label [required]="true">Due Date:</app-form-label>
                <mat-form-field appearance="outline" *ngIf="RequestForm?.get('Priority')?.value === 4">
                    <input
                        type="text"
                        formControlName="DueDate"
                        matInput
                        aria-label="Request Due Date"
                        [matDatepicker]="dueDatePicker"
                        [matDatepickerFilter]="IsValidWorkday.bind(this)"
                        placeholder="Select due date..."
                    />
                    <mat-datepicker-toggle matSuffix [for]="dueDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #dueDatePicker></mat-datepicker>
                    <mat-error *ngIf="RequestForm?.get('DueDate')?.hasError('matDatepickerFilter')">Monday to Friday only</mat-error>
                    <mat-error *ngIf="RequestForm?.get('DueDate')?.hasError('required')">Required.</mat-error>
                </mat-form-field>
                <div *ngIf="RequestForm?.get('Priority')?.value !== 4 && RequestForm?.get('DueDate')?.value">
                    {{ RequestForm?.get('DueDate')?.value | date: 'M/d/yyyy' }}
                </div>
            </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
            <div
                fxLayout="row"
                fxLayoutAlign="start center"
                fxLayoutGap="15px"
                *ngIf="
                    (User?.CurrentRole === 'Facilitator' || User?.CurrentRole === 'Developer') &&
                    RequestForm?.get('Source')?.value === 0
                "
                fxFlex="45"
                fxFlex.lt-md="auto"
            >
                <app-form-label [required]="true">Board Member:</app-form-label>
                <mat-form-field appearance="outline" fxFlex fxFlex.gt-sm="50">
                    <mat-select
                        matInput
                        formControlName="RequestBoardMember"
                        placeholder="Board Member..."
                        aria-label="Request Board Member Selection List"
                    >
                        <mat-option [value]="null">Board Member...</mat-option>
                        <mat-option *ngFor="let board of BoardMembers" [value]="board"
                            >{{ board.LastName | titleCase }}, {{ board.FirstName | titleCase }} - District
                            {{ board.District }}</mat-option
                        >
                    </mat-select>
                    <mat-error *ngIf="RequestForm?.get('RequestBoardMember')?.hasError('required')">Required.</mat-error>
                </mat-form-field>
            </div>
        </div>
        <div
            fxLayout="row"
            fxLayoutAlign="start center"
            fxLayoutGap="30px"
            fxLayout.lt-md="column"
            fxLayoutAlign.lt-md="start stretch"
            fxLayoutGap.lt-md="10px"
        >
            <div
                fxLayout="row"
                fxLayoutAlign="start center"
                fxLayoutGap="15px"
                *ngIf="User?.CurrentRole === 'Facilitator' || User?.CurrentRole === 'Developer'"
                fxFlex="45"
                fxFlex.lt-md="auto"
            >
                <app-form-label>School:</app-form-label>
                <mat-form-field appearance="outline" fxFlex>
                    <mat-select
                        matInput
                        formControlName="SchoolNumber"
                        placeholder="School..."
                        aria-label="Request School Selection List"
                    >
                        <mat-option [value]="null">All / District-Wide</mat-option>
                        <mat-option *ngFor="let sch of AllSchools" [value]="sch.SchoolNumber"
                            >{{ sch.SchoolName }} ({{ sch.SchoolNumber }})</mat-option
                        >
                    </mat-select>
                </mat-form-field>
            </div>
            <div
                fxLayout="row"
                fxLayoutAlign="start center"
                fxLayoutGap="15px"
                *ngIf="User?.CurrentRole === 'Facilitator' || User?.CurrentRole === 'Developer'"
            >
                <app-form-label>District:</app-form-label>
                <mat-form-field appearance="outline">
                    <mat-select
                        matInput
                        formControlName="BoardDistrict"
                        placeholder="District..."
                        aria-label="Request District Selection List"
                    >
                        <mat-option [value]="null">All / District-Wide</mat-option>
                        <mat-option *ngFor="let dist of ['1', '2', '3', '4', '5', '6', '7']" [value]="dist">{{ dist }}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="constituentbox" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
            <mat-checkbox formControlName="IsConstituent">Is this request on behalf of a constituent?</mat-checkbox>
            <div *ngIf="RequestForm?.get('IsConstituent')?.value" fxLayoutGap.lt-md="10px">
                <!--
                fxLayout="column"
                fxLayoutAlign="start stretch"
                fxFlex="100" fxFlex.lt-md="auto"
            -->
                <em>For your convenience/reference, you may record the constituent's name and email in the space provided here:</em>
                <div
                    fxLayout="row"
                    fxLayoutAlign="start center"
                    fxLayoutGap="30px"
                    fxLayout.lt-md="column"
                    fxLayoutAlign.lt-md="start stretch"
                    fxLayoutGap.lt-md="10px"
                >
                    <div
                        fxLayout="row"
                        fxLayoutAlign="start center"
                        fxLayoutGap="15px"
                        fxFlex="45"
                        fxFlex.lt-md="auto"
                        fxLayout.lt-md="column"
                        fxLayoutAlign.lt-md="start stretch"
                        fxLayoutGap.lt-md="5px"
                    >
                        <app-form-label>Constituent Name:</app-form-label>
                        <mat-form-field appearance="outline" fxFlex>
                            <input type="text" matInput formControlName="ConstituentName" placeholder="Enter name..." />
                        </mat-form-field>
                    </div>
                    <div
                        fxLayout="row"
                        fxLayoutAlign="start center"
                        fxLayoutGap="15px"
                        fxFlex="45"
                        fxFlex.lt-md="auto"
                        fxLayout.lt-md="column"
                        fxLayoutAlign.lt-md="start stretch"
                        fxLayoutGap.lt-md="5px"
                    >
                        <app-form-label>Constituent Email:</app-form-label>
                        <mat-form-field appearance="outline" fxFlex>
                            <input type="email" matInput formControlName="ConstituentEmail" placeholder="Enter email..." />
                        </mat-form-field>
                    </div>
                    <div
                        fxLayout="row"
                        fxLayoutAlign="start center"
                        fxLayoutGap="15px"
                        fxFlex="45"
                        fxFlex.lt-md="auto"
                        fxLayout.lt-md="column"
                        fxLayoutAlign.lt-md="start stretch"
                        fxLayoutGap.lt-md="5px"
                    >
                        <app-form-label>Constituent Phone:</app-form-label>
                        <mat-form-field appearance="outline" fxFlex>
                            <input type="text" matInput formControlName="ConstituentPhone" placeholder="Enter phone..." />
                        </mat-form-field>
                    </div>
                </div>
                <mat-checkbox formControlName="ConstituentPrivate"
                    >Keep constituent information private (not visible to other users)</mat-checkbox
                >
            </div>
        </div>
        <section class="mat-elevation-z5">
            <mat-tab-group [(selectedIndex)]="SelectedTabIndex" [dynamicHeight]="true">
                <mat-tab>
                    <ng-template mat-tab-label>Request / Concern</ng-template>
                    <div fxLayout="column" fxLayoutAlign="start stretch" class="padding-top">
                        <div>
                            Enter request text here. This text will be provided to the supervisor who will be responding to this
                            request. Please be as descriptive as necessary in your request.
                        </div>
                        <mat-form-field appearance="outline" floatLabel="never">
                            <textarea
                                matInput
                                matTextareaAutosize
                                [matAutosizeMinRows]="10"
                                formControlName="RequestText"
                                maxlength="5000"
                                placeholder="Type text here..."
                            ></textarea>
                            <mat-hint align="start">Limit of 5,000 characters</mat-hint>
                            <mat-hint align="end">{{ RequestForm?.get('RequestText')?.value?.length || 0 }}/5000</mat-hint>
                            <mat-error *ngIf="RequestForm?.get('RequestText')?.hasError('required')">Required.</mat-error>
                            <mat-error *ngIf="RequestForm?.get('RequestText')?.hasError('maxLength')"
                                >Over character limit (5000).</mat-error
                            >
                        </mat-form-field>
                        <mat-checkbox formControlName="Confidential"
                            >This request contains confidential student and/or parent information.</mat-checkbox
                        >
                        <div *ngIf="IsiPad" class="margin-top">
                            <em
                                >File attachment uploads may not be possible from an Apple iPhone or iPad device. To reliably upload
                                files, please log in to the IRIS system using a desktop device to create a request that includes file
                                attachments.</em
                            >
                        </div>
                        <div class="margin-top">
                            <div>
                                Would you like to add a file attachment to your request? Please note the following limitations for file
                                attachments:
                            </div>
                            <ul>
                                <li>Each individual file attachment is limited to 50MB in size.</li>
                                <li>There can be no more than five (5) files attached to a single request.</li>
                            </ul>
                            <app-file-uploader
                                buttonText="Add Attachment(s)"
                                color="primary"
                                icon="attach_file"
                                (upload)="HandleFileAttachment($event)"
                            ></app-file-uploader>
                            <div
                                *ngIf="
                                    RequestForm?.get('RequestUploadAttachments') &&
                                    !!RequestForm?.get('RequestUploadAttachments')?.length
                                "
                                class="margin-top"
                            >
                                <h3 class="mat-h3">Files to be attached:</h3>
                                <div
                                    fxLayout="row wrap"
                                    fxLayoutAlign="start center"
                                    fxLayoutGap="30px"
                                    formArrayName="RequestUploadAttachments"
                                >
                                    <div
                                        fxLayout="column"
                                        fxLayoutAlign="start center"
                                        *ngFor="let item of RequestForm.get('RequestUploadAttachments')?.controls; index as $index"
                                        [formGroup]="item"
                                    >
                                        <button type="button" mat-raised-button color="accent" (click)="RemoveFile($index)">
                                            <span>{{ item.get('File')?.value.name }}</span>
                                            <mat-icon matSuffix>delete</mat-icon>
                                        </button>
                                        <span>{{ item.get('File')?.value.size | fileSize: 2 }}</span>
                                    </div>
                                </div>
                                <div class="margin-top">
                                    <em>Note: Click a file button above to remove from the pending uploads list.</em>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab *ngIf="User?.CurrentRole === 'Facilitator' || User?.CurrentRole === 'Developer'">
                    <ng-template mat-tab-label>Notes For Cabinet Member</ng-template>
                    <div fxLayout="column" fxLayoutAlign="start stretch" class="padding-top">
                        <div>
                            In the space below, you may provide any optional comments you wish to
                            <span *ngIf="!RequestForm?.get('RequestCategory')?.value">the cabinet member</span
                            ><span *ngIf="RequestForm?.get('RequestCategory')?.value"
                                >{{ RequestForm?.get('RequestCategory')?.value?.CabinetMember?.FirstName | titleCase }}
                                {{ RequestForm?.get('RequestCategory')?.value?.CabinetMember?.LastName | titleCase }}</span
                            >
                            regarding this request. These comments will only be visible to this cabinet member, and not to any other
                            individual in the IRIS System.
                        </div>
                        <mat-form-field appearance="outline" floatLabel="never">
                            <textarea
                                matInput
                                matTextareaAutosize
                                [matAutosizeMinRows]="10"
                                formControlName="SourceNotes"
                                maxlength="5000"
                                placeholder="Type text here..."
                            ></textarea>
                            <mat-hint align="start">Limit of 5,000 characters</mat-hint>
                            <mat-hint align="end">{{ RequestForm?.get('SourceNotes')?.value?.length || 0 }}/5000</mat-hint>
                            <mat-error *ngIf="RequestForm?.get('SourceNotes')?.hasError('required')">Required.</mat-error>
                            <mat-error *ngIf="RequestForm?.get('SourceNotes')?.hasError('maxLength')"
                                >Over character limit (5000).</mat-error
                            >
                        </mat-form-field>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </section>
        <div>
            <em
                ><strong>Please note: </strong>New requests entered after 4:00pm on a workday, or during weekends or holidays, will be
                handled as soon as possible on the next business day.</em
            >
        </div>
        <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="15px" class="actionbar">
            <button type="button" mat-raised-button color="warn" (click)="ClearRequestForm(true)">Clear Form</button>
            <button type="button" mat-raised-button color="primary" (click)="AddNewRequest()">Add Request</button>
        </div>
    </form>
</div>
